import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice";
import SpecializationAreas from "../../../../components/ui/SpecializationAreas";
import InputField1 from "../../../../components/ui/InputField1";
import FileInput from "../../../../components/ui/FileInput";
import { Grid2 as Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";

function Therapist({ errors, files, onChangFun, persistedData }) {
  const dispatch = useDispatch();
  const [areas, setAreas] = useState([]);
  const { specialist } = useSelector((state) => state.specialistSlice);

  const handleGetAreas = (filters) => {
    dispatch(
      getAllSpecializationAreasReq({
        limit: filters?.limit || 10,
        id: "67d90056c2c4d5ab747f8b38",
      })
    )
      .unwrap()
      .then((data) => {
        setAreas(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleGetAreas();
    // eslint-disable-next-line
  }, []);

  const getDefaultValue = (field, apiPath) => {
    if (persistedData?.[field]) {
      return persistedData[field];
    }
    return apiPath || "";
  };

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          label="Qualifications *"
          name="specializationCertificate"
          errText="Please upload qualifications"
          placeholderText="Upload Qualifications"
          defaultValue={
            files.current.specializationCertificate?.length
              ? files.current.specializationCertificate
              : specialist?.profile?.specializationCertificate || []
          }
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="therapeuticMethods"
          label="Therapeutic Methods *"
          errText="Please enter therapeutic methods"
          defaultValue={getDefaultValue(
            "therapeuticMethods",
            specialist?.profile?.therapeuticMethods
          )}
          key={getDefaultValue(
            "therapeuticMethods",
            specialist?.profile?.therapeuticMethods
          )}
          placeholder="Describe the therapeutic methods you use, such as Cognitive Behavioral Therapy (CBT), Dialectical Behavior Therapy (DBT), etc"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          persistedData={persistedData}
          specialist={specialist}
          files={files}
          label="Specialization Areas *"
        />
      </Grid>

      <Typography color="#7A8A9E" fontWeight="500" fontStyle="italic">
        Support your clients' mental health and well-being. Detail your
        therapeutic methods and areas of expertise
      </Typography>
    </Fragment>
  );
}

export default Therapist;
